module.exports = __webpack_public_path__ + "static/media/Kaveh Hassani.e34cf024.png";